// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__55C5T","contentWrapper":"MainPage_contentWrapper__gbSm9","content":"MainPage_content__VmCCM"};